import { useMemo } from 'react';

import { useFlag } from 'analytics';
import { User } from 'redux/types/user';
import { canAccessWithAdminBypass } from 'utils/permissions';

import { NavGroup, NavItem } from '../Sidebar.types';
import { ACADEMY_ITEM, ADMIN_ITEMS, CUENTA_ITEMS, PRINCIPAL_BASE_ITEMS, REPORTE_ITEM } from '../sidebarNavConfig';

const applyPermissionFilter = (
  items: NavItem[],
  permissions: string[] | undefined,
  isAdmin: boolean,
  countryCode: string | undefined
): NavItem[] => {
  return items.filter((item) => {
    if (!item.permissions) return true;
    if (!permissions?.length) return false;
    return canAccessWithAdminBypass({ isAdmin, userPermissions: permissions, countryCode }, item.permissions);
  });
};

const useNavigationGroups = (currentUser: User | null, isMobile = false): NavGroup[] => {
  const isAcademyEnabled = useFlag('academy');

  return useMemo(() => {
    if (!currentUser) return [];

    const { isAdmin, permissions, subProjectId, countryCode } = currentUser;

    const principalItems = applyPermissionFilter(
      [
        ...PRINCIPAL_BASE_ITEMS,
        ...(!subProjectId || isAdmin ? [REPORTE_ITEM] : []),
        ...(isAcademyEnabled || isAdmin ? [ACADEMY_ITEM] : []),
      ].filter((item) => !(isMobile && item.desktopOnly)),
      permissions,
      isAdmin,
      countryCode
    );

    return [
      { label: 'Principal', defaultOpen: false, items: principalItems },
      {
        label: 'Cuenta',
        defaultOpen: false,
        items: applyPermissionFilter(CUENTA_ITEMS, permissions, isAdmin, countryCode),
      },
      ...(isAdmin
        ? [
            {
              label: 'Administración',
              defaultOpen: false,
              items: applyPermissionFilter(ADMIN_ITEMS, permissions, isAdmin, countryCode),
            },
          ]
        : []),
    ];
  }, [currentUser, isMobile, isAcademyEnabled]);
};

export default useNavigationGroups;
